/**
 * Client mirror of functions/src/cardPoLinkedCharges.ts — append/dedupe + sum.
 */

import { roundMoney, type LinkedCardChargeLite } from './cardPoAutoPurchase';

export function normalizeLinkedExpenseIds(
  qbExpenseIds?: unknown,
  qbExpenseId?: unknown,
): string[] {
  const out: string[] = [];
  const seen = new Set<string>();
  const push = (raw: unknown) => {
    const id = typeof raw === 'string' ? raw.trim() : '';
    if (!id || seen.has(id)) return;
    seen.add(id);
    out.push(id);
  };
  if (Array.isArray(qbExpenseIds)) {
    for (const value of qbExpenseIds) push(value);
  }
  push(qbExpenseId);
  return out;
}

export function appendLinkedExpenseId(existing: string[], expenseId: string): string[] {
  const id = expenseId.trim();
  if (!id) return normalizeLinkedExpenseIds(existing);
  if (existing.some(row => row === id)) return [...existing];
  return [...existing, id];
}

export function removeLinkedExpenseId(existing: string[], expenseId: string): string[] {
  const id = expenseId.trim();
  if (!id) return [...existing];
  return existing.filter(row => row !== id);
}

export function sumLinkedChargeAmounts(charges: LinkedCardChargeLite[]): number {
  return roundMoney(charges.reduce((sum, row) => sum + (Number(row.totalAmount) || 0), 0));
}
